/** Resolve the i18n key for the browser tab title from the current path. */
export function titleKeyForPath(pathname: string, reviewLabelKey: string): string {
  if (pathname === "/") return "nav.home";
  if (pathname.startsWith("/politique-de-confidentialite")) return "pages.legal";
  if (pathname.startsWith("/dashboard")) return "nav.dashboard";
  if (pathname.startsWith("/hub")) return "nav.hub";
  if (pathname.startsWith("/indicators")) return "nav.indicators";
  if (pathname.startsWith("/measures")) return "nav.measures";
  if (pathname.startsWith("/n1")) return "nav.n1";
  if (pathname.startsWith("/n2")) return "nav.n2";
  if (pathname.startsWith("/n3")) return "nav.n3";
  if (pathname.startsWith("/review")) return reviewLabelKey;
  if (pathname.startsWith("/source-report")) return "nav.sourceReport";
  if (pathname.startsWith("/settings")) return "nav.settings";
  if (pathname.startsWith("/login")) return "nav.login";
  if (pathname.startsWith("/unauthorized")) return "pages.unauthorizedTitle";
  if (pathname.startsWith("/forbidden")) return "pages.forbiddenTitle";
  return "pages.notFoundTitle";
}
